// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2020-05-19 02:04:37 +0200 (Tue, 19 May 2020) $
// Author      : Ulrich Mierendorff
// Worker      : $Author: u.mierendorff $
// Revision    : $Rev: 110588 $
// Purpose     : Database Administration and Debugging Parts
// =============================================================================

export const parts = true

import * as views from './views'
export {views}
